var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8945 0.6274V6.32799H19.3353C19.0039 5.01287 18.6363 4.07053 18.2325 3.50099C17.8286 2.9211 17.2746 2.46029 16.5704 2.11856C16.1769 1.93217 15.4883 1.83897 14.5046 1.83897H12.9357V18.0864C12.9357 19.1634 12.9927 19.8365 13.1066 20.1057C13.2309 20.3749 13.4638 20.6131 13.8056 20.8202C14.1577 21.017 14.634 21.1153 15.2346 21.1153H15.9336V21.6901H4.9052V21.1153H5.60418C6.21514 21.1153 6.70702 21.0066 7.07981 20.7892C7.34905 20.6442 7.56133 20.3957 7.71666 20.0436C7.83057 19.795 7.88752 19.1427 7.88752 18.0864V1.83897H6.36529C4.94662 1.83897 3.91627 2.13927 3.27424 2.73988C2.37333 3.57866 1.80379 4.77469 1.56562 6.32799H0.975365V0.6274H19.8945Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/Text Icon.73ef638cc6a01126b94207f162f4674e.svg";
export { ForwardRef as ReactComponent };